<edl-floating-label-container label="Title" [for]="'title-' + questionId" class="mb-2">
    <input [id]="'title-' + questionId" type="text" class="form-control" placeholder="Insert short title here" formControlName="title" />
</edl-floating-label-container>
<hr />
<edl-floating-label-container label="Signature type" [for]="signatureTypeId">
    <select [id]="signatureTypeId" class="form-select" formControlName="option">
        <option [ngValue]="CustomFormSignatureType.TARGET_USER">Employee</option>
        <option [ngValue]="CustomFormSignatureType.SUPERVISOR">Supervisor</option>
        <option [ngValue]="CustomFormSignatureType.ADMIN">Administrator</option>
    </select>
</edl-floating-label-container>


